import React, { useState, useEffect, useContext } from "react";
import { AppBar, Tabs, Tab } from "@material-ui/core";
import EscaneoSimple from "./EscaneoSimple";
import socketio from "socket.io-client";
import config from "../../../config";

const EscaneoEvidencia = () => {
  const [appBarValue, setAppBarValue] = useState(0);
  const [reloadComponent, setReloadComponent] = useState(false);
  const [socketId, setSocketId] = useState(null);
  
  useEffect(() => {
    let socket = socketio.connect(config.SOCKET_URL, {
      closeOnBeforeunload: false,
    });

    // subscribe to socket events
    socket.on("connect", () => {
      handleConect(socket.id);
    });
    socket.on("scanned", handleScanned); 

    return () => {
      // before the component is destroyed
      // unbind all event handlers used in this component
      socket.off("scanned", handleScanned);
      socket.off("connect", handleConect);
      socket.close();
    };

    // eslint-disable-next-line
  }, []);

  const handleScanned = () => {
    setReloadComponent(true);
    setTimeout(() => {
      setReloadComponent(false);
    }, 2000);
  }
  const handleConect = (socketid) => {
    setSocketId(socketid)
  }

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  const handleChange = (event, newValue) => {
    setAppBarValue(newValue);
  };

  return (
    <div>
   {/*    <AppBar position="static">
        <Tabs
          value={appBarValue}
          onChange={handleChange}
          aria-label="simple tabs example"
          centered
        >
          <Tab label="Escaneo Simple" {...a11yProps(0)} />
          <Tab label="Escaneo Multiple" {...a11yProps(1)} />
        </Tabs>
      </AppBar> */}
      {
        {
          0: <EscaneoSimple socketId={socketId} reloadComponent={reloadComponent} />,
        }[appBarValue]
      }
    </div>
  );
};

export default EscaneoEvidencia;
